import React, { memo } from 'react'

import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/material'
import { useScreenDimensions } from '@shared/hooks/useScreenDimensions'

import { ChipListWrapper, ChipWrapper, StyledChip } from './index.styles'

export interface ChipItemData {
  label: string
  key: string
  metaData?: unknown
}

interface ChipItemProps {
  data: ChipItemData
  onDelete: (i: ChipItemData) => void
}

const ChipItem = memo((props: ChipItemProps) => {
  const { data, onDelete } = props

  return (
    <ChipWrapper>
      <StyledChip
        label={data.label}
        onDelete={() => onDelete(data)}
        variant="outlined"
        /** inline styles is needed here */
        deleteIcon={
          <CloseIcon
            style={{ fontSize: 15.5, fill: '#000000' }}
            data-testid={`${data.key}_delete_chip_icon`}
            className="search_chip-delete"
          />
        }
      />
    </ChipWrapper>
  )
})

export interface ChipListProps {
  items: ChipItemData[]
  onDelete: (i: ChipItemData) => void
  renderLabel?: () => React.JSX.Element
  renderAdditionalItems?: () => React.JSX.Element
}

const ChipList = (props: ChipListProps) => {
  const { isMobile } = useScreenDimensions()
  const { items, onDelete, renderLabel, renderAdditionalItems } = props

  return (
    <ChipListWrapper>
      {isMobile ? (
        <Box display="flex" flexDirection="column" gap="10px">
          <Box>{renderLabel?.()}</Box>
          <Box display="flex" alignItems="center" gap="5px" flexWrap="wrap">
            {items?.map(i => (
              <ChipItem key={i.key} data={i} onDelete={onDelete} />
            ))}
          </Box>
          <Box display="flex" alignItems="center" gap="5px">
            {renderAdditionalItems?.()}
          </Box>
        </Box>
      ) : (
        <>
          {renderLabel?.()}

          {items?.map(i => (
            <ChipItem key={i.key} data={i} onDelete={onDelete} />
          ))}

          {renderAdditionalItems?.()}
        </>
      )}
    </ChipListWrapper>
  )
}

export default memo(ChipList)
